import React, { useMemo } from 'react'
import moment from 'moment'
import { DeviceMap } from './device-map'
import { ButtonPrimary, ButtonSecondary } from '../../../shared/component/button'
import { IconShield } from '../../../shared/icon/icon'
import { DeviceGlyph } from './device-glyph'
import { CodeCountdown } from '../../../shared/component/countdown'
import { ErrorReference } from '../../../shared/error/error-reference'

export const ConfirmView = ({ device, error, failure, submitting, onReject, onApprove }) => {
  const when = useMemo(() => moment(device && device.requestedAt).format('h:mm A · MMM D, YYYY'), [device])
  return (
    <div className="ld-confirm">
      <div className="ld-pill"><span className="ld-pill__dot" />SIGN-IN REQUESTED</div>

      {/* Display-only: approving an expired code still fails server-side. */}
      {device && device.expiresAt && <CodeCountdown expiresAt={device.expiresAt} className="ld-countdown" />}

      <div className="ld-device">
        <div className="ld-device__tile">
          <DeviceGlyph family={device && device.family} brand={device && device.brand} />
        </div>
        <div className="ld-device__meta">
          <div className="ld-device__name">{device && device.label}</div>
          {device && device.app && <div className="ld-device__app">{device.app}</div>}
          {device && device.os && <div className="ld-device__os">{device.os}</div>}
        </div>
      </div>

      <div className="ld-when">
        <div className="ld-when__label">WHEN</div>
        <div className="ld-when__primary">Just now</div>
        <div className="ld-when__dim">{when}</div>
      </div>

      {device && device.location && <DeviceMap code={device.code} location={device.location} />}

      <div className="ld-note">
        <IconShield className="ld-note__icon" />
        <div>
          Don't recognize this? Tap <span className="ld-note__reject">Deny</span> to refuse this sign-in. The device will be told the request was denied.
        </div>
      </div>

      {error && <div className="text-danger text-center mb-2">{error}</div>}
      {error && <ErrorReference error={failure} className="mx-auto mb-2" />}

      <div className="ld-actions">
        <ButtonSecondary text="Deny" onClick={onReject} disabled={submitting} />
        <ButtonPrimary text="Approve" onClick={onApprove} disabled={submitting} />
      </div>
    </div>
  )
}
